import { useState } from 'react'
import { HeaderNull } from '../../../component/HeaderNull'
import './KhuyenMaiMobile.scss'
import { KhuyenMai } from './KhuyenMai'
import { ThuThap } from './ThuThap'
import { HoatDongDeXuat } from './HoatDongDeXuat'

function KhuyenMaiMobile () {
  const [datahead, setdatahead] = useState('การส่งเสริม')
  const dataheads = [
    {
      name: 'การส่งเสริม'
    },
    // {
    //   name: 'Hoạt động được đề xuất'
    // },
    // {
    //   name: 'Thu thập'
    // }
  ]
  return (
    <div>
      <HeaderNull title={'กิจกรรมส่งเสริมการขาย'} link={'/usermobile'} />
      <div
        style={{ marginTop: '50px' }}
        className='activity-category-mobile-wrap'
      >
        <div className='activity-category-mobile'>
          {dataheads.map((item, index) => (
            <div
              className={`activity-category-mobile-item ${
                datahead === item.name
                  ? 'activity-category-mobile-item_active'
                  : ''
              } `}
              onClick={() => setdatahead(item.name)}
              key={index}
            >
              {item.name}
            </div>
          ))}
        </div>
        <div className='activity-category-mobile-list'>
          {datahead === 'การส่งเสริม' && <KhuyenMai />}
          {/* {datahead === 'Thu thập' && <ThuThap />}
          {datahead === 'Hoạt động được đề xuất' && <HoatDongDeXuat />} */}
        </div>
      </div>
    </div>
  )
}

export default KhuyenMaiMobile
